import React from 'react';
import { faQuestionCircle } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { BoldSmallBodyText, Header5Text, SmallBodyText, SpacerRow, Tooltip } from 'ui-toolkit';

export const ExpectedSellerMoneyLabel: React.FC = () => {
  return (
    <Tooltip
      placement={'bottom'}
      tooltipContent={
        <>
          <BoldSmallBodyText>What is this?</BoldSmallBodyText>
          <SmallBodyText>
            This represents the value of funds that Spruce expects to fulfill Seller Cash to Close.
          </SmallBodyText>
          <SpacerRow />
          <BoldSmallBodyText>How is it calculated?</BoldSmallBodyText>
          <SmallBodyText>
            Seller closing costs to be paid at closing
            <br />
            + Adjustments paid by seller
            <br />
            - Adjustments paid on behalf of buyer
            <br />
            - Purchase price
            <br />= Expected Seller Money
          </SmallBodyText>
        </>
      }
    >
      <div className={'flex flex-row gap-1 items-center'}>
        <Header5Text>Seller</Header5Text>
        <FontAwesomeIcon icon={faQuestionCircle} />
      </div>
    </Tooltip>
  );
};
